'use strict'

import Basic from '../../Controller/Basic'
import Common from '../../Utils/Common'

export default class ManageCheckboxSelectionStatus {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.manage-checkbox-selection-status')
	 * @param {Form} controller - Formコントローラー
	 */
	constructor($e, controller) {
		console.log(`ManageCheckboxSelectionStatus.constructor`)
		this._$e = $e
		this._controller = controller
		this._basicController = new Basic()
		this._hasQueryParameter = location.href.includes('?')
		this._ids = []
		this._omitIds = []
		this._$checkAllButton = $('[data-selection-type=all]')
		this._$uncheckAllButton = $('[data-selection-type=nothing]')
		this._$selectButtons = $('input.check-all-target')
		this._$outputButton = $('.btn-output')
		this._$selectedCount = $('.selected-count')
		this._searchResultCount = Number(this._$selectedCount.data('search-result-count')) || 0
		this._localStoragePrefix = this.getLocalStoragePrefix()
		this._basicController._listener.on('clear-local-storage', () => this.clearLocalStorage())
		this._$checkAllButton.on('click', () => this.onCheckAllButtonClick())
		this._$uncheckAllButton.on('click', () => this.onUncheckAllButtonClick())
		this._$outputButton.on('click', () => this.onOutputButtonClick())
		this._$selectButtons.each((_, element) => $(element).on('click', (e) => this.onSelectButtonClick(e)))
		this.initialize()
	}


	/**
	 * 初期化
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	initialize() {
		console.log('ManageCheckboxSelectionStatus.initialize')
		this._hasQueryParameter ? $('#output-options-wrap').show() : this.clearLocalStorage()
		localStorage.getItem(`${this._localStoragePrefix}_selection_type`) ?? this.updateSelectionType(this._$uncheckAllButton.data('value'))
		if(this.getIdsFromLocalStorage().length > 0){
			console.log('元々 ids が local storageにあった場合、復帰')
			this._ids = this.getIdsFromLocalStorage();
		}
		if(this.getOmitIdsFromLocalStorage().length > 0){
			console.log('元々 omitIds が local storageにあった場合、復帰')
			this._omitIds = this.getOmitIdsFromLocalStorage();
		}
		console.log(this._ids)
		console.log(this._omitIds)
		this.updateSelectButtonStateAlongLocalStorage()
		this.updateSelectedCount()
	}


	/**
	 * LocalStorageに保存するパラメータ名のプレフィックスを返す
	 * LocalStorage用なので意図的に略している
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	getLocalStoragePrefix() {
		switch (true) {
			case $('body').hasClass('page-certificates'):
				// certificates
				console.log(`prefix: c`)
				return 'c'
			case $('body').hasClass('page-membership-registration-certificate'):
				// membership-registration-certificate
				console.log(`prefix: mrc`)
				return 'mrc'
			default:
				console.log('prefixを確定するためのbodyタグのクラスがありません。')
				return ''
		}
	}


	/**
	 * ローカルストレージをクリアする
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	clearLocalStorage() {
		console.log(`ManageCheckboxSelectionStatus.clearLocalStorage`)
		localStorage.removeItem(`${this._localStoragePrefix}_selection_type`)
		localStorage.removeItem(`${this._localStoragePrefix}_ids`)
		localStorage.removeItem(`${this._localStoragePrefix}_omit_ids`)
	}


	/**
	 * ローカルストレージから selection_type を取得する
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {string} - initializeでローカルストレージのselection_typeはセットされるのでnullが返ることはない
	 */
	getSelectionTypeFromLocalStorage() {
		return localStorage.getItem(`${this._localStoragePrefix}_selection_type`)
	}


	/**
	 * ローカルストレージから ids を取得する
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {Array | null}
	 */
	getIdsFromLocalStorage() {
		let ls = []
		if (localStorage.getItem(`${this._localStoragePrefix}_ids`)){
			ls = JSON.parse(localStorage.getItem(`${this._localStoragePrefix}_ids`))
		}
		return ls
	}


	/**
	 * ローカルストレージから omit_ids を取得する
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {Array | null}
	 */
	getOmitIdsFromLocalStorage() {
		let ls = []
		if (localStorage.getItem(`${this._localStoragePrefix}_omit_ids`)){
			return JSON.parse(localStorage.getItem(`${this._localStoragePrefix}_omit_ids`))
		}
		return ls
	}


	/**
	 * 全選択ボタンクリックコールバック
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	onCheckAllButtonClick() {
		console.log(`ManageCheckboxSelectionStatus.onCheckAllButtonClick`)
		this.updateSelectionType(this._$checkAllButton.data('value'))
		this._omitIds = []
		localStorage.setItem(`${this._localStoragePrefix}_omit_ids`, JSON.stringify(this._omitIds))
		this.updateSelectButtonStateAlongLocalStorage()
		this.updateSelectedCount()
	}


	/**
	 * 全解除ボタンクリックコールバック
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	onUncheckAllButtonClick() {
		console.log(`ManageCheckboxSelectionStatus.onUncheckAllButtonClick`)
		this.updateSelectionType(this._$uncheckAllButton.data('value'))
		this._ids = []
		localStorage.setItem(`${this._localStoragePrefix}_ids`, JSON.stringify(this._ids))
		this.updateSelectButtonStateAlongLocalStorage()
		this.updateSelectedCount()
	}


	/**
	 * 選択ボタンクリックコールバック
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	onSelectButtonClick(e) {
		console.log(`ManageCheckboxSelectionStatus.onSelectButtonClick`)
		console.log(`checked: ${$(e.currentTarget).prop('checked')} / value: ${$(e.currentTarget).val()}`)
		switch ($(e.currentTarget).prop('checked')) {
			case true:
				!this._ids.includes($(e.currentTarget).val()) && (this._ids = this._ids.concat($(e.currentTarget).val()))
				this._omitIds = this._omitIds.filter(id => id != $(e.currentTarget).val())
				break
			case false:
				!this._omitIds.includes($(e.currentTarget).val()) && (this._omitIds = this._omitIds.concat($(e.currentTarget).val()))
				this._ids = this._ids.filter(id => id != $(e.currentTarget).val())
		}
		console.log(this._ids)
		console.log(this._omitIds)
		localStorage.setItem(`${this._localStoragePrefix}_ids`, JSON.stringify(this._ids))
		localStorage.setItem(`${this._localStoragePrefix}_omit_ids`, JSON.stringify(this._omitIds))
		this.updateSelectedCount()
	}


	/**
	 * ローカルストレージのselection_typeを更新する
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @param {string} type
	 * @return {undefined}
	 */
	updateSelectionType(type) {
		localStorage.setItem(`${this._localStoragePrefix}_selection_type`, type)
		console.log(`localStorage.${this._localStoragePrefix}_selection_type: ${this.getSelectionTypeFromLocalStorage()}`)
	}


	/**
	 * ローカルストレージの {prefix}_ids に応じて選択ボタンの状態を更新
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	updateSelectButtonStateAlongLocalStorage() {
		console.log(`ManageCheckboxSelectionStatus.updateSelectButtonStateAlongLocalStorage`)
		const selection_type = this.getSelectionTypeFromLocalStorage()
		const ids = this.getIdsFromLocalStorage()
		const omit_ids = this.getOmitIdsFromLocalStorage()
		console.log(`selection_type: ${selection_type}`)
		console.log(ids)
		console.log(omit_ids)
		switch (selection_type) {
			case this._$checkAllButton.data('value'):
				if (!omit_ids) return console.log(`omit_ids is ${null}`)
				this._$selectButtons.each((_, element) => {
					$(element).prop('checked', !omit_ids.includes($(element).val()))
				})
				break
			case this._$uncheckAllButton.data('value'):
				if (!ids) return console.log(`ids is ${null}`)
				this._$selectButtons.each((_, element) => {
					$(element).prop('checked', ids.includes($(element).val()))
				})
				break
			default:
				console.log('selection_type is unset')
		}
	}


	/**
	 * 出力するボタンクリックコールバック
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	onOutputButtonClick() {
		console.log(`ManageCheckboxSelectionStatus.onOutputButtonClick`)
		this._controller._listener.trigger('validate')
		if ($('.is-invalid:not(.ignore-validation)').length) {
			Common.showErrorModal('入力内容に誤りがあります。')
			return
		}
		if (this.getSelectionTypeFromLocalStorage() == this._$uncheckAllButton.data('value')) {
			const ids = this.getIdsFromLocalStorage() ?? []
			if (!ids.length) {
				Common.showErrorModal('出力対象が選択されていません。')
				return
			}
		}
		const formData = new FormData(document.getElementById(this._$e.attr('id')))
		formData.append('selection_type', this.getSelectionTypeFromLocalStorage())
		formData.append('ids', this.getIdsFromLocalStorage() ?? [])
		formData.append('omit_ids', this.getOmitIdsFromLocalStorage() ?? [])
		Common.logFormData(formData)
		this._controller.submitDataForOutputFiles(this._$e, formData, this.getLocalStoragePrefix())
	}


	/**
	 * 選択中の件数表示を更新
	 *
	 * @memberof ManageCheckboxSelectionStatus
	 * @return {undefined}
	 */
	updateSelectedCount() {
		console.log(`ManageCheckboxSelectionStatus.updateSelectedCount`)
		const selection_type = this.getSelectionTypeFromLocalStorage()
		const ids = this.getIdsFromLocalStorage() ?? []
		const omit_ids = this.getOmitIdsFromLocalStorage() ?? []
		switch (selection_type) {
			case this._$checkAllButton.data('value'):
				this._$selectedCount.text(`（${this._searchResultCount - omit_ids.length}件選択中）`)
				break
			case this._$uncheckAllButton.data('value'):
				this._$selectedCount.text(`（${ids.length}件選択中）`)
				break
			default:
				console.log('selection_type is unset')
		}
	}
}
